import { render, staticRenderFns } from "./assignments.vue?vue&type=template&id=a0bf026c&scoped=true&"
import script from "./assignments.vue?vue&type=script&lang=ts&"
export * from "./assignments.vue?vue&type=script&lang=ts&"
import style0 from "./assignments.vue?vue&type=style&index=0&id=a0bf026c&lang=less&scoped=true&"
import style1 from "./assignments.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bf026c",
  null
  
)

export default component.exports